
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcast/[playlists]",
      function () {
        return require("private-next-pages/podcast/[playlists]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcast/[playlists]"])
      });
    }
  